import { Box, BoxProps, CloseButton, Flex, Text } from '@mantine/core';
import stylesRevamp from '../theme/ModalRevamp.module.css';
import ModalBackButton from './ModalBackButton';

type ModalBoxProps = {
  children: React.ReactNode;
  title?: string | null;
  showModalControls?: boolean;
  onClose?: () => void;
  previousStep?: () => void;
  canGoBack?: boolean;
} & BoxProps;

export default function ModalBox({
  children,
  title,
  onClose,
  showModalControls = true,
  previousStep,
  canGoBack,
  ...props
}: ModalBoxProps) {
  return (
    <Box
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'stretch',
        backgroundColor: 'var(--mantine-color-white)',
        borderRadius: '12px',
        padding: 'var(--mantine-spacing-md)',
        overflow: 'hidden',
      }}
      {...props}
    >
      {previousStep && (
        <ModalBackButton previousStep={previousStep} canGoBack={Boolean(canGoBack)} />
      )}
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          width: '100%',
          overflow: 'hidden',
          maxHeight: '100%',
          height: '100%',
          borderRadius: 0,
        }}
        className={showModalControls ? stylesRevamp.content : ''}
      >
        <Flex
          justify="space-between"
          mb="md"
          mt="xxs"
          style={
            showModalControls
              ? {
                  marginTop: 44,
                  paddingTop: 'var(--mantine-spacing-lg)',
                  paddingBottom: 0,
                }
              : undefined
          }
        >
          {showModalControls && (
            <Box
              style={{
                position: 'absolute',
                top: 0,
                left: -5,
                right: -5,
                height: 44,
                backgroundImage: 'url("/images/modal-border-bg.png")',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
              }}
            />
          )}
          <Text className={stylesRevamp.title}>{title}</Text>
          {showModalControls && (
            <CloseButton
              c="white"
              onClick={onClose}
              style={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            />
          )}
        </Flex>
        <Flex
          flex={1}
          style={{
            overflowY: 'auto',
          }}
        >
          {children}
        </Flex>
      </Box>
    </Box>
  );
}
